import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Limitation, 
  LimitationConstructor, 
  Limitations, 
} from "@dndModels";
import { 
  CHARACTER_LEVELS 
} from "@dndModels/Constants";

import LimitationInput from "@dndComponents/limitations/LimitationInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import AddButton from "@components/input/buttons/AddButton";

interface Props { 
  obj: Limitations;
  disabled: boolean;
  change_time: number;
  onChange: (changed: Limitations) => void; 
}

export default function LimitationsInput({
  obj,
  disabled,
  change_time,
  onChange,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: obj.level_type === "Class" ? 6 : 12
        }}>
        <SelectStringBox
          name="Level Type"
          options={["Character","Class","Inherit"]}
          value={obj.level_type}
          onChange={(changed: "Character" | "Class" | "Inherit") => {
            const new_limits = obj;
            new_limits.level_type = changed;
            onChange(new_limits);
          }}
        />
      </Grid>
      { obj.level_type === "Class" &&
        <Grid
          size={{
            xs: 6
          }}>
          <SelectObjectBox
            name="For Class"
            data_type="game_class"
            value={obj.for_class_id}
            onChange={(changed: string) => {
              const new_limits = obj;
              new_limits.for_class_id = changed;
              onChange(new_limits);
            }}
          />
        </Grid>
      }
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Limitations
        </span>
        { !disabled &&
          <AddButton
            onClick={ () => {
              const new_limits = obj;
              const highest_level = ( Math.max(0,...obj.limits.map(o => o.limit_level)));
              const limit_level = highest_level + 1;
              const highest_limit = obj.limits.find(o => o.limit_level === highest_level);
              const new_obj = highest_limit ? highest_limit.toDBObj() : { limitation_type: obj.limitation_type, limit_level };
              new_obj.limit_level = limit_level;
              new_limits.limits.push(LimitationConstructor(new_obj));
              onChange(new_limits);
            }}
          />
        }
      </Grid>
      { obj.limits.map((limit, key) => {
        return (
          <Grid
            key={key}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 2
              }}>
              <SelectStringBox
                name="Level"
                options={CHARACTER_LEVELS}
                value={`${limit.limit_level}`}
                onChange={(changed: string) => {
                  limit.limit_level = +changed;
                  onChange(obj);
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 10
              }}>
              <LimitationInput
                obj={limit}
                disabled={disabled}
                change_time={change_time}
                onChange={(changed: Limitation) => {
                  // debugger;
                  limit.copy(changed.clone());
                  onChange(obj);
                }}
                onDelete={() => {
                  const new_limits = obj;
                  new_limits.limits = new_limits.limits.filter(o => o.true_id !== limit.true_id);
                  onChange(new_limits);
                }} 
              />
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}